import { Collapse, Typography } from "@mui/material"

import Button from "@components/button"
import PageHeader from "@components/page_header"
import { useAppContext } from "@contexts/app_context"

export default function AppAlert() {
  const { isAppBarOpen, toggleAppBarOpen } = useAppContext()

  return (
    <Collapse in={isAppBarOpen}>
      <PageHeader>
        <Button onClick={toggleAppBarOpen}>
          <Typography>Close App Bar</Typography>
        </Button>
      </PageHeader>
    </Collapse>
  )
}
